import 'dayjs/locale/ru';

export class CurrentLocale {
  static locale = 'ru';

  static init(djs: any) {
    djs.locale(this.locale);
  }
}
